import React, { useContext, useEffect, useState } from 'react';
import KeyboardDoubleArrowLeftIcon from '@mui/icons-material/KeyboardDoubleArrowLeft';
import KeyboardDoubleArrowRightIcon from '@mui/icons-material/KeyboardDoubleArrowRight';
import List from '@mui/material/List';
import {
  IconButton,
  ListItem,
  Tooltip,
  Typography,
  Box,
  Grid,
  SwipeableDrawer,
  useMediaQuery,
  useTheme,
} from '@mui/material';
import styled from '@emotion/styled';
import MuiDrawer from '@mui/material/Drawer';
import { NavLink } from 'react-router-dom';
import { makeStyles, withStyles } from '@mui/styles';
import { AuthContext } from '../../Context/authContext';
import routes from '../../Constants/routes';
// import FacebookIcon from '../../Assets/SvgImages/FacebookIcon.svg';
// import LinkedinIcon from '../../Assets/SvgImages/LinkedinIcon.svg';
// import TwitterIcon from '../../Assets/SvgImages/TwitterIcon.svg';
import HomeNav from '../../Assets/Svg/home.svg';
import MyApplicationNav from '../../Assets/Svg/applications.svg';
import DocumentNav from '../../Assets/Svg/document.svg';
// import OfferLetterIcon from '../../Assets/SvgImages/OfferLetterIcon.svg';
import clsx from 'clsx';
import ExitToAppOutlinedIcon from '@mui/icons-material/ExitToAppOutlined';
import { TABLET_BREAKPOINT } from '../../Constants/constant';
import { getRenderingDetails } from '../../Utils/apiServices';

const drawerWidth = 210;

const useStyles = makeStyles((theme) => ({
  listItem: {
    padding: '12px 20px',
    width: 'calc(100% + 20px)',
    marginBottom: 8,
    '&:hover': {
      width: 'calc(100% + 20px)',
      backgroundColor: theme.palette.KenColors.sideNavItemHoverBackground,
      borderRadius: '24px 0px 0px 24px',

      '& $subLevel': {
        color: theme.palette.KenColors.sideNavItemHoverColor,
      },
      '& $heading': {
        color: theme.palette.KenColors.sideNavItemHoverColor,
      },
    },
    '&.Mui-selected': {
      backgroundColor: 'turquoise',
      color: 'white',
      fontWeight: 600,
      borderRadius: '24px 0px 0px 24px',
    },
    borderRadius: '24px 0px 0px 24px',
  },
  active: {
    '& $listItem': {
      width: 'calc(100% + 20px)',
      // backgroundColor: '#4290BD',
      backgroundColor: '#6675ff',
      borderRadius: '24px 0px 0px 24px',
    },

    '& $subListItem': {
      borderLeft: `4px solid ${theme.palette.KenColors.kenWhite}`,
      marginLeft: 0,
      backgroundColor: theme.palette.KenColors.sideNavItemActiveBackground,
      borderRadius: '24px 0px 0px 24px',
    },

    '& $heading': {
      color: theme.palette.KenColors.sideNavItemActiveColor,
    },
    '& $subLevel': {
      color: theme.palette.KenColors.sideNavItemActiveColor,
    },
    '&.Mui-selected': {
      backgroundColor: theme.palette.KenColors.sideNavItemActiveBackground,
      color: 'white',
      fontWeight: 600,
      borderRadius: '24px 0px 0px 24px',

      '&:hover': {
        backgroundColor: theme.palette.KenColors.sideNavItemActiveBackground,
        // color: 'white',
        borderRadius: '24px 0px 0px 24px',
      },
    },
    textDecoration: 'none',
    borderRadius: '24px 0px 0px 24px',
  },
  menuIcon: {
    color: theme.palette.KenColors.kenWhite,

    '& >p': {
      display: 'flex',
      color: theme.palette.KenColors.kenWhite,
    },
  },
  heading: {
    fontStyle: 'normal',
    fontWeight: 'normal',
    fontSize: '0.875rem',
    lineHeight: '20px',
    display: 'flex',
    alignItems: 'center',
    color: theme.palette.KenColors.kenWhite,
  },
  drawer: {
    justifyContent: 'space-between',
    width: drawerWidth,
    flexShrink: 0,
    whiteSpace: 'nowrap',
    // background: 'linear-gradient(176.94deg, #158ABB 14.53%, #060B6B 95.84%)',
    background: 'rgb(46, 49, 146)',
    margin: 16,
    borderRadius: 12,
    height: '95vh',
    [theme.breakpoints.down('md')]: {
      margin: 0,
      borderRadius: '0px 24px 24px 0px',
      height: '100vh',
      'overflow-x': 'hidden',
    },
  },
  root: {
    [theme.breakpoints.down(TABLET_BREAKPOINT)]: {
      // Note: added so side bar drawer show on top of header when active
      'z-index': '1302',
    },
  },
  icon: {
    color: theme.palette.KenColors.kenWhite,
  },
  link: {
    textDecoration: 'none',
  },
  typoReserved: {
    fontSize: 10,
    color: theme.palette.KenColors.kenWhite,
  },
  typoReservedOpen: {
    width: 88,
    whiteSpace: 'initial',
  },
  imageBanner: {
    // width: 76,
    height: 70,
    marginLeft: 8,
  },
  imageBannerDetailed: {
    height: 70,
    // height: 85,
    marginLeft: 8,
  },
}));

const DrawerHeader = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'flex-end',
  padding: theme.spacing(0, 1),
  // necessary for content to be below app bar
  ...theme.mixins.toolbar,
}));

const DrawerFooter = styled('div', {
  shouldForwardProp: (prop) => prop !== 'open',
})(({ theme, open }) => ({
  opacity: 1,
  marginBottom: theme.spacing(3),
  ...theme.mixins.toolbar,
}));

const Drawer = styled(MuiDrawer, {
  shouldForwardProp: (prop) => prop !== 'open',
})(({ theme, open }) => ({
  width: drawerWidth,
  flexShrink: 0,
  whiteSpace: 'nowrap',
  boxSizing: 'border-box',
  ...(open && {
    ...openedMixin(theme),
    '& .MuiDrawer-paper': openedMixin(theme),
  }),
  ...(!open && {
    ...closedMixin(theme),
    '& .MuiDrawer-paper': closedMixin(theme),
  }),
}));

const openedMixin = (theme) => ({
  width: drawerWidth,
  transition: theme.transitions.create('width', {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.enteringScreen,
  }),
  overflowX: 'hidden',
  display: 'relative',
});

const closedMixin = (theme) => ({
  transition: theme.transitions.create('width', {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  overflowX: 'hidden',
  width: `calc(${theme.spacing(8)} + 1px)`,
  [theme.breakpoints.up('sm')]: {
    width: `calc(${theme.spacing(12)} + 1px)`,
  },
});

const LightTooltip = withStyles((theme) => ({
  tooltip: {
    backgroundColor: theme.palette.common.white,
    color: 'rgba(0, 0, 0, 0.87)',
    boxShadow: theme.shadows[1],
    fontSize: 14,
  },
}))(Tooltip);

const menu = [
  {
    icon: <img src={HomeNav} alt="" />,
    label: 'Home',
    link: `/${routes.home}`,
    callback: '',
  },
  {
    icon: <img src={MyApplicationNav} alt="" />,
    label: 'My Applications',
    link: `/${routes.myApplications}`,
    callback: '',
  },
];

const GetSideNavData = (data) => {
  const classes = useStyles();
  const { open, handleDrawerClose, handleDrawerOpen, sideNavMenu } = data;
  const theme = useTheme();

  const currentYear = new Date().getFullYear();

  return (
    <>
      <Box>
        <DrawerHeader>
          <Grid container direction="column">
            <Grid
              item
              style={{ textAlign: 'left', marginTop: 16, minHeight: 92 }}
              display="flex"
              justifyContent="center"
              alignItems="center"
            >
              <img
                // src={FinalLogo}
                // src={"https://apply-vvi.force.com/servlet/servlet.ImageServer?id=0155g000000cne9&oid=00D5g000004yu1Y"}
                src={
                  open
                    ? 'https://flamestorageken42.blob.core.windows.net/flame-storage-ken42/sideNavLogo.jpg'
                    : 'https://flamestorageken42.blob.core.windows.net/flame-storage-ken42/sideNavLogo.jpg'
                }
                // src={"https://inazstgpfs3001.blob.core.windows.net/assets/Blue-Logo-CAPS-800x117.png"}
                alt="Ken42 Icon"
                className={clsx(classes.imageBanner, {
                  [classes.imageBannerDetailed]: open === true,
                })}
              />
            </Grid>
            <Grid
              item
              style={{ textAlign: 'right', marginRight: -12, paddingTop: 16 }}
              sx={{ display: { xs: 'none', tablet: 'block' } }}
            >
              <IconButton onClick={open ? handleDrawerClose : handleDrawerOpen}>
                {!open ? (
                  <KeyboardDoubleArrowRightIcon className={classes.icon} />
                ) : (
                  <KeyboardDoubleArrowLeftIcon className={classes.icon} />
                )}
              </IconButton>
            </Grid>
          </Grid>
        </DrawerHeader>
        <List
          sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            paddingLeft: open ? '40px' : undefined,
          }}
        >
          {sideNavMenu &&
            sideNavMenu?.map((item, index) => {
              return (
                <NavLink
                  key={index}
                  to={
                    item?.link === null || item?.link === undefined ? (
                      <Typography>{item?.link}</Typography>
                    ) : (
                      item?.link
                    )
                  }
                  className={({ isActive }) =>
                    isActive ? classes.active : classes.link
                  }
                >
                  <ListItem
                    onClick={item.callback}
                    classes={{
                      root: classes.listItem,
                      selected: classes.active,
                    }}
                    button
                  >
                    <Grid
                      container
                      alignItems="center"
                      sx={{ minWidth: open ? 180 : undefined }}
                    >
                      <Grid item sx={{ minWidth: open ? '32px' : undefined }}>
                        {open === false ? (
                          <LightTooltip
                            title={item.label}
                            placement="right-end"
                          >
                            <span className={classes.menuIcon}>
                              <Typography>{item.icon}</Typography>
                            </span>
                          </LightTooltip>
                        ) : (
                          <span className={classes.menuIcon}>
                            <Typography>{item.icon}</Typography>
                          </span>
                        )}
                      </Grid>
                      <Grid item>
                        {open && (
                          <span className={classes.heading}>{item.label}</span>
                        )}
                      </Grid>
                    </Grid>
                  </ListItem>
                </NavLink>
              );
            })}
        </List>
      </Box>
      <DrawerFooter open={open}>
        <Grid
          container
          alignItems="center"
          justifyContent="center"
          direction="column"
        >
          <Grid item marginBottom={theme.spacing(2)}>
            <>
              {/* <Grid
                container
                spacing={open ? 2 : 1}
                direction={open ? 'row' : 'column'}
              >
                <Grid item display="flex" alignItems="flex-end">
                <a href="https://www.facebook.com/NITTEedu/" target="_blank">
                  <img src={FacebookIcon} />
                  </a>
                </Grid>
                <Grid item display="flex" alignItems="flex-end">
                <a href="https://twitter.com/aboutnitte?ref_src=twsrc%5Egoogle%7Ctwcamp%5Eserp%7Ctwgr%5Eauthor" target="_blank">
                  <img src={TwitterIcon} />
                  </a>
                </Grid>
                <Grid item display="flex" alignItems="flex-end">
                <a href="https://in.linkedin.com/company/nitte-edu" target="_blank">
                  <img src={LinkedinIcon} />
                  </a>
                </Grid>
              </Grid> */}
            </>
          </Grid>
          <Grid item>
            <Typography
              className={clsx(classes.typoReserved, {
                [classes.typoReservedOpen]: open === false,
              })}
            >
              © {currentYear} All rights Reserved
            </Typography>
          </Grid>
        </Grid>
      </DrawerFooter>
    </>
  );
};

export default function SideNavigation(props) {
  const [sideNavMenu, setSideNavMenu] = useState(menu);
  const classes = useStyles();
  const theme = useTheme();
  const isMobileScreen = useMediaQuery(
    theme.breakpoints.down(TABLET_BREAKPOINT)
  );
  const smallScreen = useMediaQuery(theme.breakpoints.down('sm'));

  const {
    state: { user },
    dispatch,
  } = useContext(AuthContext);
  const { open, setSwipeableDrawer, swipeableDrawer, setOpen } = props;

  useEffect(() => {
    setSideNavMenu((prev) => {
      let temp = [
        ...sideNavMenu.map((i) => {
          // Note: added to close drawer on mobile devices
          if (typeof i?.callback !== 'function') {
            i.callback = () => {
              setSwipeableDrawer(false);
            };
          }
          return i;
        }),
      ];

      // Check side menu is not already having logout button
      if (
        smallScreen &&
        (sideNavMenu || []).filter((s) => s.label === 'Logout').length === 0
      ) {
        temp.push({
          icon: <ExitToAppOutlinedIcon />,
          label: 'Logout',
          link: ``,
          callback: () => {
            dispatch({
              type: 'LOGOUT',
              payload: {
                user: {},
                token: null,
              },
            });
          },
        });
      }

      return temp;
    });
  }, [isMobileScreen, smallScreen]);

  useEffect(() => {
    if (isMobileScreen) {
      setOpen(true);
    } else {
      setOpen(false);
    }
  }, [isMobileScreen]);

  const toggleDrawer = (event) => {
    setSwipeableDrawer(false);
  };

  return (
    <Box sx={{ m: isMobileScreen ? undefined : 2 }}>
      {!isMobileScreen ? (
        <Drawer
          variant="permanent"
          open={open}
          classes={{ paper: classes.drawer, root: classes.root }}
        >
          <GetSideNavData sideNavMenu={sideNavMenu} {...props} />
        </Drawer>
      ) : (
        <SwipeableDrawer
          anchor={'left'}
          open={swipeableDrawer}
          onClose={toggleDrawer}
          classes={{ paper: classes.drawer, root: classes.root }}
        >
          <GetSideNavData sideNavMenu={sideNavMenu} {...props} />
        </SwipeableDrawer>
      )}
    </Box>
  );
}
